/* eslint-disable no-loop-func */
import React from 'react';
import PropTypes from 'prop-types';
import { T, Masks, retrievePrecisionNumber, C } from 'shared/helpers';

import Styles from './Table.module.scss';

import Select from 'components/Template/Select/Select';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash } from '@fortawesome/free-solid-svg-icons';

export default function Table({
  n,
  fenologica,
  aplicacao,
  produtos,
  fprodutos,
  quantidades,
  valores,
  tableKey,
  phase,
  setter,
  renderables,
  etapaid,
  medida,
  updateMedida,
}) {
  const { Table, Row, Block, Item, Offset, TextArea } = Styles;

  const { number } = Masks;

  const width = '150px';
  const height = 'auto';
  let rowCount = 0;
  const k = () => `${tableKey}${++rowCount}`;

  const Selects = [];
  const Rows = [];

  const prods = produtos.map((x) => ({
    label: x.classificacao
      ? x.user_id
        ? `${x.nome} (${x.classificacao})`
        : x.nome
      : x.nome,
    value: x.id,
  }));
  const mapProdutos = useSelector((state) => state.produtos.map || {});

  const percents = ['N', 'P2O5', 'K2O', 'Qtde (Kg/ha)'];

  if (produtos instanceof Array) {
    for (let i = 1; i <= 10; i++) {
      const conditions = [
        [Number(T(fprodutos)[i]) && !Number(T(quantidades)[i]), Styles.Warning],
        [Number(T(fprodutos)[i]) && !Number(T(valores)[i]), Styles.Error],
      ];
      Selects.push(
        <div
          key={k()}
          className={C(Item, ...conditions)}
          style={{ minWidth: '200px', maxWidth: '200px' }}
        >
          <Select
            id={`produtos_selector_${i.toString()}`}
            nullable={true}
            options={prods}
            valueRef={T(fprodutos)[i]}
            disabled={!fenologica}
            setValueRef={(value) =>
              setter((form) =>
                value
                  ? {
                      ...form,
                      produtos: {
                        ...form.produtos,
                        [n]: { ...form.produtos[n], [i]: value },
                      },
                    }
                  : {
                      ...form,
                      produtos: {
                        ...form.produtos,
                        [n]: { ...form.produtos[n], [i]: undefined },
                      },
                      quantidade: {
                        ...form.quantidade,
                        [n]: { ...form.quantidade[n], [i]: undefined },
                      },
                      valor: {
                        ...form.valor,
                        [n]: { ...form.valor[n], [i]: undefined },
                      },
                    },
              )
            }
            placeholder={
              T(mapProdutos[T(fprodutos)[i]], {
                nome: '(Nenhum)',
              }).nome
            }
            style={{
              boxShadow: 'none',
              borderRadius: '5px',
              border: '1px solid grey',
            }}
            boxStyle={{ borderRadius: '5px', fontSize: '0.3em' }}
            optionStyle={{ fontSize: '0.6em' }}
            listStyle={{
              maxHeight: '180px',
              marginTop: i > 4 ? '-180px' : '0px',
            }}
          />
        </div>,
      );

      Rows.push(
        <div key={k()} className={C(Row, ...conditions)}>
          {percents.map((x, i2) => (
            <div
              style={{
                fontSize: '2.5em',
                minWidth: x.length > 8 ? '120px' : undefined,
              }}
              className={Block}
              key={`${tableKey}_frame${++rowCount}`}
            >
              {x.length < 8 ? (
                number(
                  T(mapProdutos[T(fprodutos)[i]], {
                    [x]: '0.00',
                  })[x] || '0.00',
                  { suffix: '%' },
                )
              ) : (
                <NumberFormat
                  disabled={(fprodutos[i] && fenologica) ? undefined : true}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  id={`input_${i}_${i2}`}
                  value={
                    T(quantidades)[i] !== undefined
                      ? Number(T(quantidades)[i])
                      : ''
                  }
                  onValueChange={(value) =>
                    setter((form) => ({
                      ...form,
                      quantidade: {
                        ...form.quantidade,
                        [n]: {
                          ...form.quantidade[n],
                          [i]: value.floatValue,
                        },
                      },
                    }))
                  }
                  type='text'
                />
              )}
            </div>
          ))}
          {renderables.map((x) => (
            <div key={k()} style={{ fontSize: '2.5em' }} className={Block}>
              {number(
                (Number(
                  T(mapProdutos[T(fprodutos)[i]], {
                    [x]: 0,
                  })[x],
                ) /
                  100) *
                  T(quantidades)[i] || 0,
                {
                  ed: retrievePrecisionNumber(x),
                },
              )}
            </div>
          ))}
          <div
            style={{ fontSize: '2.5em', minWidth: '150px' }}
            className={C(Block, [conditions[1][0], Styles.Empty])}
          >
            <NumberFormat
              disabled={(fprodutos[i] && fenologica) ? undefined : true}
              thousandSeparator={'.'}
              decimalSeparator={','}
              prefix={'R$ '}
              suffix={' /ton'}
              decimalScale={2}
              fixedDecimalScale={true}
              value={T(valores)[i] !== undefined ? Number(T(valores)[i]) : ''}
              onValueChange={(value) =>
                setter((form) => ({
                  ...form,
                  valor: {
                    ...form.valor,
                    [n]: {
                      ...form.valor[n],
                      [i]: value.floatValue,
                    },
                  },
                }))
              }
              type='text'
            />
          </div>
        </div>,
      );
    }
  }

  // const _cleanForm = useCallback((form) => {
  //   const Clean = (key, fallback) =>
  //       O(
  //         Object.keys(form[key]).filter((x) => String(x) !== String(n)),
  //         Object.entries(form[key])
  //           .filter((x) => String(x[0]) !== String(n))
  //           .map((x) => x[1]),
  //         fallback,
  //       );
  //   return {
  //     ...form,
  //     fenologica: Clean('fenologica', ''),
  //     aplicacao: Clean('aplicacao', ''),
  //     etapa_id: Clean('etapa_id', null),
  //     produtos: Clean('produtos', {}),
  //     quantidade: Clean('quantidade', 0),
  //     valor: Clean('valor', 0),
  //     local_id: Clean('local_id', null),
  //   };
  // });
  // const _clearStepDefinition = useCallback(() => {
  //   setter(_cleanForm);
  // }, [n]);

  const onChange = ({ target: { name, value } }) => {
    if (name !== 'fenologica') {
      // For any field that is not fenologica, just set the field
      setter((form) => ({
        ...form,
        [name]: {
          ...form[name],
          [n]: value,
        },
      }));
    } else {
      // If is fenologica and has value
      setter((form) => ({
        ...form,
        [name]: {
          // Set fenologica
          ...form[name],
          [n]: value, // Value
        },
        aplicacao: {
          ...form.aplicacao,
          [n]: form.aplicacao[n] || null,
        },
        etapa_id: {
          ...form.etapa_id,
          [n]: etapaid || null, // Set the etapa id
        },
        produtos: { ...form.produtos, [n]: form.produtos[n] || {} }, // Empty the products
        quantidade: { ...form.quantidade, [n]: form.quantidade[n] || {} }, // Empty the quantidades
        valor: { ...form.valor, [n]: form.valor[n] || {} }, // Empty the valores
      }));
    }
  };

  return (
    <div className={Table}>
      <header>
        {/* <div></div> */}
        <div style={{ minWidth: width }}>Etapa Fenológica</div>
        <div style={{ minWidth: width }}>Época de Aplicação</div>
        <div style={{ minWidth: '210px' }}>Produto</div>
        <div>N</div>
        <div>P2O5</div>
        <div>K2O</div>
        <div style={{ minWidth: '120px' }}>
          <input
            value={medida}
            placeholder={'Qtde (Kg/ha)'}
            onChange={({ target: { value } }) => updateMedida(value)}
          />
        </div>
        {renderables.map((x) => (
          <div key={`${tableKey}_row${rowCount++}`}>{x}</div>
        ))}
        <div style={{ minWidth: '150px' }}>Preço do Produto (R$/ton)</div>
      </header>
      <div>
        <div className={Row}>
          {/* <div>
            <FontAwesomeIcon icon={faTrash} onClick={clearStepDefinition} />
          </div> */}
          <div
            className={Block}
            style={{ minWidth: width, maxWidth: width, height }}
          >
            <input
              {...{ disabled: phase === 2 ? 'disabled' : undefined }}
              className={TextArea}
              name={'fenologica'}
              onChange={onChange}
              value={fenologica}
            />
          </div>
          <div
            className={Block}
            style={{ minWidth: width, maxWidth: width, height }}
          >
            <input
              {...{ disabled: phase === 2 ? 'disabled' : undefined }}
              className={TextArea}
              name={'aplicacao'}
              onChange={onChange}
              value={aplicacao}
            />
          </div>
          <div
            style={{
              minWidth: '200px',
              maxWidth: '200px',
              height,
              display: 'block',
            }}
            className={Block}
          >
            {Selects}
          </div>
          <div className={Offset}>{Rows}</div>
        </div>
      </div>
    </div>
  );
}

Table.defaultProps = {
  fenologica: '',
  aplicacao: '',
  produtos: [],
  fprodutos: {},
  quantidades: {},
  valores: {},
  tableKey: 'nutritionalEditor_Table_',
};

Table.propTypes = {
  n: PropTypes.number.isRequired,
  fenologica: PropTypes.string,
  aplicacao: PropTypes.string,
  produtos: PropTypes.array,
  fprodutos: PropTypes.object,
  quantidades: PropTypes.object,
  valores: PropTypes.object,
  tableKey: PropTypes.string,
  phase: PropTypes.number.isRequired,
  setter: PropTypes.func.isRequired,
  renderables: PropTypes.array.isRequired,
  etapaid: PropTypes.any.isRequired,
};
